import type { TrackingEventName, TrackingProperties } from "../types";

declare global {
  interface Window {
    FS?: (
      action: "trackEvent",
      payload: { name: string; properties: TrackingProperties },
    ) => void;
  }
}

// Fullstory dashboards are built on these names, so they are kept apart from
// the vendor-facing event names. Events not listed here aren't sent.
const FULLSTORY_EVENTS: Partial<
  Record<TrackingEventName, { name: string; category: string }>
> = {
  Login: { name: "loginSuccess", category: "authentication" },
  Registration: { name: "registrationSuccess", category: "authentication" },
};

const sendToFullstory = (
  event: TrackingEventName,
  payload: TrackingProperties,
) => {
  const fullstoryEvent = FULLSTORY_EVENTS[event];
  if (!fullstoryEvent) {
    return;
  }
  const { name, category } = fullstoryEvent;
  window.FS?.("trackEvent", { name, properties: { category, ...payload } });
};

export default sendToFullstory;
